import { Component, OnInit } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { TranslateService, TranslatePipe } from '@ngx-translate/core';
import { MessageBeep } from 'src/app/wings-mobile/services/messageBeep/messageBeep.service';
import { PrinterService } from 'src/app/wings-mobile/services/printer/printer.service';
import { ButtonDirective } from 'primeng/button';

@Component({
    selector: 'inbound',
    templateUrl: './inbound.component.html',
    styleUrls: ['./inbound.component.css'],
    imports: [ButtonDirective, RouterLink, TranslatePipe]
})
export class InboundComponent implements OnInit {

	constructor(
		private printerService: PrinterService,
		private beep: MessageBeep,
		private translate: TranslateService,
		private route: Router
	) {
		this.printerService = printerService;
		this.beep = beep;
		this.translate = translate;
		this.route = route;
	}

	ngOnInit() { }

	hasPrinter(): void {
		this.printerService.hasQuery().subscribe({
			next: () => { this.route.navigateByUrl('/receiving'); },
			error: () => {
				this.beep.showAlertCustom("modal.error", 'modal.printerNotFound');
			}
		});
	}
}

